const initialState = {
    data: [],
  };
  
  const stawkiIndReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'SET_STAWKI_IND':
        return { ...state, data: action.payload };
      default:
        return state;
    }
  };
  
  export default stawkiIndReducer;